import { UNAVAILABLE_CODES } from '@/constants/no-results';

export const DELIVERY_EVENTS = Object.freeze({
  UNAVAILABLE: {
    ZIP_CODE_UNAVAILABLE: 'Delivery Unavailable',
    FLORIST_UNAVAILABLE: 'Florist Delivery Unavailable',
    GIFT_BASKET_UNAVAILABLE: 'Gift Basket Delivery Unavailable',
    TREE_UNAVAILABLE: 'Christmas Tree Delivery Unavailable',
    DROPSHIP_UNAVAILABLE: 'Direct Ship Unavailable'
  },

  DAY_OF_WEEK_UNAVAILABLE: {
    FLORIST: {
      SUNDAY: 'Sunday Florist Delivery Unavailable',
      SATURDAY: 'Saturday Florist Delivery Unavailable'
    },
    DROPSHIP: {
      SUNDAY: 'Sunday Dropship Delivery Unavailable'
    }
  },

  SAME_DAY_DELIVERY_FEE: {
    ZIP_CODE: 'Same Day Delivery Fee'
  },

  SAME_DAY_CUTOFF_PRIORITY: {
    PRODUCT: {
      SATURDAY: 'Product Cutoff',
      SUNDAY: 'Product Cutoff',
      WEEKDAY: 'Product Cutoff'
    },
    ZIP_CODE: {
      SATURDAY: 'Saturday Same Day Cutoff',
      SUNDAY: 'Sunday Same Day Cutoff',
      WEEKDAY: 'Weekday Same Day Cutoff'
    }
  },

  FLORIST_EXPEDITED: {
    UNAVAILABLE: 'Florist Expedited Delivery Unavailable',
    BELOW_MINIMUM: 'Below Florist Expedited Minimum',
    PRICE: 'Florist Morning Expedite Price'
  },

  BELOW_FLORIST_ZIP_CODE_MINIMUM: 'Below Florist Delivered Minimum'
});

export const UNAVAILABLE_CODE_DELIVERY_EVENT_MAP = Object.freeze({
  [UNAVAILABLE_CODES.ZIP_CODE_UNAVAILABLE]: DELIVERY_EVENTS.UNAVAILABLE.ZIP_CODE_UNAVAILABLE,
  [UNAVAILABLE_CODES.FLORIST_UNAVAILABLE]: DELIVERY_EVENTS.UNAVAILABLE.FLORIST_UNAVAILABLE,
  [UNAVAILABLE_CODES.GIFT_BASKET_UNAVAILABLE]: DELIVERY_EVENTS.UNAVAILABLE.GIFT_BASKET_UNAVAILABLE,
  [UNAVAILABLE_CODES.TREE_UNAVAILABLE]: DELIVERY_EVENTS.UNAVAILABLE.TREE_UNAVAILABLE,
  [UNAVAILABLE_CODES.DROPSHIP_UNAVAILABLE]: DELIVERY_EVENTS.UNAVAILABLE.DROPSHIP_UNAVAILABLE
});